import SectionHeading from "@/components/base/SectionHeading";
import { relationPairs } from "@/mocks/comicData";

const toneMap: Record<string, { dot: string; border: string; text: string }> = {
  warm: { dot: "bg-accent-500", border: "border-accent-200", text: "text-accent-700" },
  cool: { dot: "bg-secondary-500", border: "border-secondary-200", text: "text-secondary-700" },
  neutral: { dot: "bg-primary-400", border: "border-primary-200", text: "text-primary-700" },
};

const hub = [
  { name: "苏婉", rel: "继母" },
  { name: "苏念", rel: "继姐" },
  { name: "林正国", rel: "父亲" },
  { name: "周奶奶", rel: "邻居" },
  { name: "陈晓月", rel: "好友" },
];

export default function Relationships() {
  return (
    <section id="relationships" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="人物关系"
          title="一张图理清角色的立场与互动逻辑"
          description="继母、继姐与主角之间的关系是全篇情感主线。下面用关系网与配对卡片，把每一段互动的起点、变化与落点都说清楚。"
        />

        {/* 关系网 */}
        <div className="mt-10 rounded-3xl border border-background-200/80 bg-background-100 px-4 py-8 md:mt-14 md:px-8 md:py-10">
          <div className="grid gap-5">
            <div className="flex justify-center">
              <div className="relative w-full max-w-xs rounded-2xl bg-primary-500 px-6 py-6 text-center shadow-none">
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                  主角 · 核心
                </span>
                <div className="text-2xl font-black text-background-50">林屿</div>
                <div className="mt-1 text-xs text-primary-100">17 岁 · 高二学生</div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
              {hub.map((item) => (
                <div
                  key={item.name}
                  className="flex flex-col items-center gap-2 rounded-xl bg-background-50 border border-background-200 px-3 py-4 text-center"
                >
                  <span className="grid h-9 w-9 place-items-center rounded-full bg-secondary-100 text-secondary-800">
                    <i className="ri-user-heart-line w-4 h-4 flex items-center justify-center"></i>
                  </span>
                  <span className="text-sm font-semibold text-foreground-900">{item.name}</span>
                  <span className="text-xs text-foreground-500">{item.rel}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 配对卡片 */}
        <div className="mt-10 grid gap-5 sm:grid-cols-2 md:mt-12">
          {relationPairs.map((pair) => {
            const tone = toneMap[pair.tone] ?? toneMap.neutral;
            return (
              <article
                key={`${pair.a}-${pair.b}`}
                className="flex flex-col gap-4 rounded-2xl border border-background-200/80 bg-background-100 p-6"
              >
                <div className="flex items-center justify-between gap-3">
                  <div className="flex items-center gap-2">
                    <span className="rounded-full bg-background-50 border border-background-200 px-3 py-1 text-sm font-semibold text-foreground-900">
                      {pair.a}
                    </span>
                    <i className="ri-arrow-right-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
                    <span className="rounded-full bg-background-50 border border-background-200 px-3 py-1 text-sm font-semibold text-foreground-900">
                      {pair.b}
                    </span>
                  </div>
                  <span
                    className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${tone.border} ${tone.text}`}
                  >
                    <span className={`h-2 w-2 rounded-full ${tone.dot}`}></span>
                    {pair.type}
                  </span>
                </div>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {pair.keyword}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                    {pair.description}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}